// ═══════════════════════════════════════════════════════════════════
//  minimap/telemetry — Lightweight in-memory event log.
// ═══════════════════════════════════════════════════════════════════
//
//  Wraps the shared createTelemetryStore from `lib/telemetryStore.ts`.
//  Public API unchanged (logMinimapEvent / getMinimapTelemetryLog /
//  clearMinimapTelemetry).
//
// ═══════════════════════════════════════════════════════════════════

import { createTelemetryStore } from '@/lib/telemetryStore';
import type { MinimapTelemetryEvent } from '@/types/minimap';

const store = createTelemetryStore<MinimapTelemetryEvent>({
  debugFlag: '__FW_MINIMAP_DEBUG',
  debugPrefix: '[minimap-telemetry]',
});

export function logMinimapEvent(ev: MinimapTelemetryEvent): void {
  store.log(ev);
}

export function getMinimapTelemetryLog(): readonly MinimapTelemetryEvent[] {
  return store.get();
}

export function clearMinimapTelemetry(): void {
  store.clear();
}

/** Atomically pull the buffer for backend ingestion. */
export function takeMinimapTelemetry(): MinimapTelemetryEvent[] {
  return store.getAndClear();
}
